
export interface Database {
	id: string,
	name: string,
}

export type Timezone = string
export type MicrosoftTimezone = string
export interface Branding {
	code: string
	name: string
}
export interface BrandingInfos {
	code: string
	name: string
	webSiteUrl: string
	partnerUrl: string
	newsUrl: string
}
export const DEFAULT_BRANDING = 'ASTON_AI';

export const MS_TO_IANA = [
	{ ms: 'Romance Standard Time', iana: 'Europe/Paris' },
	{ ms: 'Central Pacific Standard Time', iana: 'Pacific/Noumea' },
]
export function msToIanaTimezone(ms: MicrosoftTimezone): Timezone {
	const tz = MS_TO_IANA.find(t => t.ms === ms)
	if (!tz) throw new Error(`Unknown Microsoft timezone: ${ms}`)
	return tz.iana;
}
